module.exports = __webpack_public_path__ + "img/certificate-IM-basic.c84b3108.png";